__turbopack_context__.v({
  "my_list_shows": "MyListShows-module-scss-module__EDcz2a__my_list_shows",
  "my_list_shows_user_prompt": "MyListShows-module-scss-module__EDcz2a__my_list_shows_user_prompt",
});
